import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { LockOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../api/axios';

const { Title, Text } = Typography;

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const payload = {
                ...values,
                token: searchParams.get('token'),
                email: searchParams.get('email')
            };
            await api.post('/reset-password', payload);
            message.success('Password reset successfully! You can now login.');
            navigate('/login');
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to reset password');
        } finally {
            setLoading(false);
        }
    };

    const inputStyle = { background: 'transparent', border: '1px solid #444', color: '#fff', height: '45px', borderRadius: '8px' };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0D0D0D' }}>
            <Card style={{ width: 420, background: '#141414', borderRadius: '16px', border: '1px solid #333' }}>
                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                    <Title level={3} style={{ color: '#fff' }}>Set New Password</Title>
                    <Text style={{ color: '#888' }}>Please enter your new secure password.</Text>
                </div>

                <Form onFinish={onFinish} layout="vertical">
                    <Form.Item name="password" label={<Text style={{color: '#888'}}>New Password</Text>} rules={[{ required: true, min: 8 }]}>
                        <Input.Password 
                            prefix={<LockOutlined style={{color: '#666'}} />} 
                            style={inputStyle}
                            iconRender={visible => (visible ? <EyeOutlined style={{color: '#888'}}/> : <EyeInvisibleOutlined style={{color: '#888'}}/>)}
                        />
                    </Form.Item>

                    <Form.Item 
                        name="password_confirmation" 
                        label={<Text style={{color: '#888'}}>Confirm Password</Text>} 
                        dependencies={['password']}
                        rules={[
                            { required: true },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) return Promise.resolve();
                                    return Promise.reject('Passwords do not match!');
                                }
                            })
                        ]}
                    >
                        <Input.Password 
                            prefix={<LockOutlined style={{color: '#666'}} />} 
                            style={inputStyle}
                            iconRender={visible => (visible ? <EyeOutlined style={{color: '#888'}}/> : <EyeInvisibleOutlined style={{color: '#888'}}/>)}
                        />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" block loading={loading} style={{ background: '#fff', color: '#000', height: '45px', fontWeight: 'bold', border: 'none' }}>
                        Reset Password
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default ResetPassword;